import { FC } from 'react'
import { formatCurrency, stringToNumber } from 'utils'

import { Input } from '../../../ui'

interface CurrencyInputProps {
  value: number | undefined
  placeholder?: string
  errorMessage: string
  updateValue: (value: number | undefined) => void
}

const CurrencyInput: FC<CurrencyInputProps> = ({
  placeholder = '$',
  value: valueFromProp,
  errorMessage,
  updateValue,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event

    if (value === '$') {
      return updateValue(0)
    }

    const valueAsNumber = stringToNumber(value, 8)

    return updateValue(valueAsNumber)
  }

  return (
    <Input
      withError={false}
      value={valueFromProp > 0 ? formatCurrency(valueFromProp, 0) : ''}
      placeholder={placeholder}
      error={errorMessage}
      onChange={handleChange}
    />
  )
}

export default CurrencyInput
